<template lang="pug">
v-select(
  v-model="selectValue",
  :options="selectOptions",
  @input="selectChange"
  )
  .search-box
    input(
      type="text",
      class="select-input",
      v-model="searchValue",
      :placeholder="placeholder",
      @keydown.enter="search"
    )
    i.fa.fa-search(@click="search")
    template(v-for="(option, key) in selectOptions")
      v-option(
        :key="option.label",
        :disabled="option.disabled",
        :label="option.label",
        :value="option.value")
</template>

<script>
  export default {
    props: {
      options: {
        type: Array,
        default: []
      },
      placeholder: {
        type: String,
        default: ''
      },
      selected: [String, Number],
      size: String,
      disabled: Boolean
    },
    data() {
      return {
        searchValue: '',
        selectValue: this.selected
      }
    },
    computed: {
      selectOptions() {
        return this.options
      }
    },
    watch: {
      selected() {
        if(this.selected != this.selectValue) {
          this.selectValue = this.selected
        }
      },
      selectOptions() {
        this.$nextTick(() => {
          this.selectValue = this.selectValue == '' ? this.selected : this.selectValue
        })
      }
    },
    methods: {
      selectChange(value) {
        if(value == '') return
        this.searchValue = ''
        this.$emit('change', value)
      },
      search() {
        this.selectValue = ''
        this.$emit('search', this.searchValue)
      }
    }
  }
</script>

<style scoped>
  .search-box {
    position: relative;
  }
  .select-input {
    border-left: 0;
    border-right: 0;
    margin: 0;
    width: 100%;
  }
  .fa-search {
    position: absolute;
    right: 5px;
    top: 17px;
    color: #acb6bf;
  }
</style>



// WEBPACK FOOTER //
// search-select.vue?1ce9db4a